import { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../components/Footer";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CourseList } from "../actions/courseActions";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import axios from "axios";

const Courses = {
  searchtxt: "",
  universityId: "",
  countryId: "",
};

function Course() {
  const [CourseFilterData, setCourseFilterData] = useState(Courses);
  const [searchParams, setSearchParams] = useSearchParams();
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [Country_Flag_Model, setCountry_Flag_Model] = useState([]);
  const [All_University_Logo, setAll_University_Logo] = useState([]);
  

  const Get_Josn_Model_Data = async () => {
    try {
      const { data } = await axios.get("./Flag.json");
      setCountry_Flag_Model(data);
      const UniversityAllRes = await axios.get("./Universities.json");
      setAll_University_Logo(UniversityAllRes?.data);
    } catch (ex) {
      console.log(ex);
    }
  };

  const { loading, error, courses } = useSelector(
    (state) => state.courseListReducer
  );

  const handleChange = (e) => {
    setCourseFilterData({
      ...CourseFilterData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      CourseFilterData?.countryId ||
      CourseFilterData?.searchtxt ||
      CourseFilterData?.universityId
    ) {
      dispatch(CourseList(CourseFilterData));
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    setCourseFilterData(Courses);
  };

  useMemo(() => {
    if (searchParams.get("course")) {
      setCourseFilterData({
        ...CourseFilterData,
        searchtxt: searchParams.get("course"),
      });
      dispatch(
        CourseList({
          ...CourseFilterData,
          searchtxt: searchParams.get("course"),
        })
      );
    }

    if (searchParams.get("country")) {
      setCourseFilterData({
        ...CourseFilterData,
        countryId: searchParams.get("country"),
      });
      dispatch(
        CourseList({
          ...CourseFilterData,
          countryId: searchParams.get("country"),
        })
      );
    }

    if (searchParams.get("university")) {
      setCourseFilterData({
        ...CourseFilterData,
        universityId: searchParams.get("university"),
      });
      dispatch(
        CourseList({
          ...CourseFilterData,
          universityId: searchParams.get("university"),
        })
      );
    }
  }, [searchParams]);

  useEffect(() => {
    Get_Josn_Model_Data();
  }, []);

  return (
    <>
      <>
        <div className="thetop"></div>
        <header className="header-section Header">
          <nav className="navbar navbar-expand-lg fixed-top" id="main_navbar">
            <div className="container navbar-container">
              <a
                onClick={() => Navigate("/")}
                className="navbar-brand white-logo"
              >
                <img
                  src={"/assets/img/SE-logo.webp"}
                  alt="Search Education"
                  width="100%"
                />
              </a>
              <a
                className="navbar-brand color-logo"
                onClick={() => Navigate("/")}
              >
                <img
                  src={"/assets/img/SE-logo.webp"}
                  alt="Search Education"
                  width="100%"
                />
              </a>
              {/* <h4>Biggest Education Fair</h4> */}
            </div>
          </nav>
        </header>
      </>
      {/* Main Body */}

      <section className="section-padding bg-f3f3f3 Main_Container">
        <div className="section-body">
          <div className="Search_Box2">
            {/* {window.innerWidth <= 480 ? (
              <div className="BTN2">
                <div>
                  <span onClick={() => Navigate("/")} className="Back_Search">
                    <IoArrowBackCircleOutline />{" "}
                  </span>
                </div>
                <div className="Select_Box">
                  <select
                    name="universityId"
                    value={CourseFilterData?.universityId}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select University</option>
                    {All_University_Logo?.map((ev) => (
                      <option key={ev.Id} value={ev.Id}>
                        {ev.Name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ) : (
              <>
                <div>
                  <span onClick={() => Navigate("/")} className="Back_Search">
                    <IoArrowBackCircleOutline />{" "}
                  </span>
                </div>
                <div className="Select_Box">
                  <select
                    name="universityId"
                    value={CourseFilterData?.universityId}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select University</option>
                    {All_University_Logo?.map((ev) => (
                      <option key={ev.Id} value={ev.Id}>
                        {ev.Name}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )} */}
            <div>
              <span onClick={() => Navigate("/")} className="Back_Search">
                <IoArrowBackCircleOutline />{" "}
              </span>
            </div>
            <div className="Select_Box">
              <select
                name="universityId"
                value={CourseFilterData?.universityId}
                onChange={handleChange}
                className="form-control"
              >
                <option value="">Select University</option>
                {All_University_Logo?.map((ev) => (
                  <option key={ev.Id} value={ev.Id}>
                    {ev.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="Select_Box">
              <select
                name="countryId"
                value={CourseFilterData?.countryId}
                onChange={handleChange}
                className="form-control"
              >
                <option value="">Select Country</option>
                {Country_Flag_Model?.map((ev) => (
                  <option key={ev.Id} value={ev.Id}>
                    {ev.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="email-subscribe">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  value={CourseFilterData?.searchtxt}
                  name="searchtxt"
                  onChange={handleChange}
                  placeholder="Search Courses"
                />
              </div>
            </div>
            {window.innerWidth <= 480 ? (
              <div className="BTN2">
                <div className="BTN">
                  <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className="Custom_btn"
                    type="button"
                  >
                    Submit
                  </button>
                </div>
                <div className="BTN">
                  <button
                    onClick={handleReset}
                    disabled={loading}
                    className="Custom_btn"
                    type="button"
                  >
                    Reset
                  </button>
                </div>
              </div>
            ) : (
              <>
                {" "}
                <div className="BTN">
                  <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className="Custom_btn"
                    type="button"
                  >
                    Submit
                  </button>
                </div>
                <div className="BTN">
                  <button
                    onClick={handleReset}
                    disabled={loading}
                    className="Custom_btn"
                    type="button"
                  >
                    Reset
                  </button>
                </div>
              </>
            )}
          </div>

          <div className="Course_Card_Section">
            {loading ? (
              <div className="BTN2">
                <h4>Loading...</h4>{" "}
              </div>
            ) : (
              ""
            )}
            {error ? (
              <div className="BTN2">
                <h4>{error}</h4>{" "}
              </div>
            ) : (
              ""
            )}
            {courses &&
              courses?.map((el, i) => (
                <div key={i + 450} className="Featured_Courses">
                  <div className="College_logo">
                    <img
                      src={
                        All_University_Logo?.find(
                          (ev) => ev.Id == el.University_Id
                        )?.Logo
                      }
                      alt={
                        All_University_Logo?.find(
                          (ev) => ev.Id == el.University_Id
                        )?.Name
                      }
                    />
                  </div>
                  <div>
                    <div>
                      <a>
                        <h4
                          className="Crs"
                          style={{
                            marginBottom: "6px",
                            fontWeight: "700",
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                          }}
                        >
                          {el?.Course_Name}
                        </h4>
                      </a>

                      <a>
                        <h6
                          style={{
                            marginBottom: "6px",
                            color: "#f36525",
                            letterSpacing: "1.5px",
                          }}
                          className="Uni"
                        >
                          {el?.University_Name}
                        </h6>
                      </a>
                    </div>
                    <div className="Details_Course">
                      <div style={{ color: "black" }}>
                        <p style={{ letterSpacing: "1px" }}>
                          Duration :{" "}
                          <span style={{ fontWeight: "600" }}>
                            {" "}
                            {el?.Duration ? `${el.Duration} Month` : ""}
                          </span>
                        </p>
                        <p style={{ letterSpacing: "1px" }}>
                          Location :{" "}
                          <span style={{ fontWeight: "600" }}>
                            {" "}
                            {el?.Country}
                          </span>
                        </p>
                        <p style={{ letterSpacing: "1px" }}>
                          Course Type :{" "}
                          <span style={{ fontWeight: "600" }}>
                            {el?.Study_Level}{" "}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p style={{ letterSpacing: "1px" }}>
                          Annual Tuition Fee:{" "}
                          <span style={{ fontWeight: "600" }}>
                            {" "}
                            {el?.Yearly_Tuition_Fees
                              ? el?.Country_Symbol +
                                " " +
                                el?.Yearly_Tuition_Fees
                              : "N/A"}
                          </span>
                        </p>

                        {/* <p style={{ letterSpacing: "1px" }}>
                          Application Deadline :{" "}
                          <span style={{ fontWeight: "600" }}>
                            {el?.Application_Deadline}{" "}
                          </span>
                        </p> */}
                      </div>
                      <div>
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div className="Course_View">
                    {el?.Course_Url ? (
                      <button
                        onClick={() => window.open(el?.Course_Url)}
                        className="Custom_btn"
                      >
                        View Course
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default Course;
